type IconProps = {
  size?: number;
};

const baseProps = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': true,
  focusable: false,
} as const;

export const HomeIcon = ({ size = 17 }: IconProps) => (
  <svg width={size} height={size} strokeWidth={2.2} {...baseProps}>
    <path d="m3 10.5 9-7 9 7V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1z" />
  </svg>
);

export const ChevronDownIcon = ({ size = 17 }: IconProps) => (
  <svg width={size} height={size} strokeWidth={2.5} {...baseProps}>
    <path d="m6 9 6 6 6-6" />
  </svg>
);
